import type { SVGProps } from "react";
export interface HillAvalancheIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HillAvalancheIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HillAvalancheIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.63 6.217a1.126 1.126 0 0 1 1.488-.241l.094.067 7.791 6.253.041.034c.704.623 1.78.559 2.404-.145a1.7 1.7 0 0 0-.022-2.278l-.124-.121a1.704 1.704 0 0 0-2.403.146l-.08.082a1.126 1.126 0 0 1-1.604-1.574l.283-.29a3.955 3.955 0 0 1 5.295-.049l.29.283a3.95 3.95 0 0 1-5.489 5.664v.003l-7.79-6.253-.086-.076a1.125 1.125 0 0 1-.088-1.505m6.511-1.585a1.376 1.376 0 0 1-.14 2.744 1.37 1.37 0 0 1-1.06-.5 1.37 1.37 0 0 1-.309-.735l-.007-.14.007-.141a1.375 1.375 0 0 1 1.369-1.233zm6-.999a1.375 1.375 0 1 1-1.509 1.507l-.007-.138.007-.141A1.375 1.375 0 0 1 21 3.626zM2.513 1.294A1.125 1.125 0 0 1 4 1.057l.094.067L7.02 3.482l.087.077a1.126 1.126 0 0 1-1.403 1.743l-.094-.068-2.928-2.358-.085-.076a1.125 1.125 0 0 1-.085-1.506Zm8.628.338a1.376 1.376 0 1 1-1.51 1.51L9.627 3l.006-.141A1.375 1.375 0 0 1 11 1.627zM.875 9.122c0-2.201 2.545-3.424 4.264-2.05l14.225 11.38c1.937 1.55.84 4.674-1.64 4.674H5A4.125 4.125 0 0 1 .875 19V9.12ZM3.125 19c0 1.035.84 1.875 1.875 1.875h12.724a.375.375 0 0 0 .234-.668L3.734 8.828a.375.375 0 0 0-.609.294z"
      />
    </svg>
  );
}
